$(document).ready(
    function () {

        let p = $("body").attr("p");
        let a = $("body").attr("a");
        if (p === 'organizer_booking_reservation' && a === 'list') {

            let locationId = $("body").attr("event_id");
            let todayDate = $('#calendar').attr('data-date');
            let bookingSummary;
            let bookingSummaryTotal;
            let dataGraph;
            let disabledDates = [];
            let calendarDate = null;

            function getBookingSummaryWeekAndMonth() {
                let bookingTotal = 0;
                let seatsTotal = 0;
                $.each(bookingSummary, (index, item) => {
                    let appendBookingSummary = "(" + item.number_of_bookings + "/" + item.number_of_seats + ")";
                    $("tr.fc-timeline-header-row th.fc-timeline-slot").each(function () {
                        if ($(this).data("date") === index && $(this).children("p.booking-summary").length) {
                            $(this).children("p.booking-summary").text(appendBookingSummary);
                            bookingTotal += item.number_of_bookings;
                            seatsTotal += item.number_of_seats;
                        }
                    });
                });
                getBookingSummaryTotal(bookingTotal, seatsTotal);
            }

            function getBookingSummaryDay() {
                let bookingTotalDay = 0;
                let seatsTotalDay = 0;
                let dateToday = new Date(todayDate);
                let slotDateString = $("tr.fc-timeline-header-row th.fc-timeline-slot").first().data("date");
                let slotDate = new Date(slotDateString);
                if (slotDate.getTime() >= dateToday.getTime()) {
                    slotDateString = slotDateString.slice(0, 10);
                    if (bookingSummary[slotDateString] !== undefined && bookingSummary[slotDateString] !== null) {
                        bookingTotalDay = bookingSummary[slotDateString].number_of_bookings;
                        seatsTotalDay = bookingSummary[slotDateString].number_of_seats;
                    }
                    getBookingSummaryTotal(bookingTotalDay, seatsTotalDay);
                }
            }

            function getBookingSummaryTotal(bookingTotal, seatsTotal) {
                let appendBookingSummaryTotal = bookingSummaryTotal;
                appendBookingSummaryTotal = appendBookingSummaryTotal.replace("NUM_BOOKINGS", bookingTotal);
                appendBookingSummaryTotal = appendBookingSummaryTotal.replace("NUM_SEATS", seatsTotal);
                $("div.fc-header-toolbar div.fc-toolbar-chunk").first().children("span.booking-summary-total").text(appendBookingSummaryTotal);
            }

            function getBookingReservations(events, update = false) {
                let lastUpdatedDate = $('#calendar').attr('data-last-updated-date');

                let employer_token = null;
                if ($("body").attr("employer_token") != undefined) {
                    employer_token = $("body").attr("employer_token");
                }

                if (update === false && $('#booking-bar-graph').length) {
                    $('#booking-bar-graph').empty();
                }

                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer_booking_reservation/get_booking_reservations",
                    data: {
                        location_id: locationId,
                        reservation_date: lastUpdatedDate,
                        is_update: update,
                        employer_token: employer_token,
                        calendar_date: calendarDate
                    }
                })
                    .done(function (data) {
                        if (data.last_updated_booking_reservations_date !== undefined && data.last_updated_booking_reservations_date !== null) {
                            $('#calendar').attr('data-last-updated-date', data.last_updated_booking_reservations_date);
                        }
                        if (data.booking_reservations !== undefined && data.booking_reservations !== null) {
                            if (!update) {
                                calendar.removeAllEvents();
                            }
                            events(JSON.parse(data.booking_reservations));
                        }
                        if (data.booking_summary_total !== undefined
                            && data.booking_summary_total !== null
                            && bookingSummaryTotal === undefined
                        ) {
                            bookingSummaryTotal = data.booking_summary_total;
                        }
                        if (data.booking_summary !== undefined && data.booking_summary !== null) {
                            bookingSummary = JSON.parse(data.booking_summary);
                            if (calendar.view.type === 'resourceTimelineMonth' || calendar.view.type === 'resourceTimelineWeek') {
                                getBookingSummaryWeekAndMonth();
                            }
                            if (calendar.view.type === 'resourceTimeline') {
                                getBookingSummaryDay();
                            }
                        }
                        if (calendar.view.type === 'resourceTimeline' && data.graph !== undefined && data.graph !== null) {
                            dataGraph = data.graph;
                            tableGraph();
                        }
                    })
                    .fail(function (data) {
                        if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                            document.location.href = data.responseJSON.redirect_url;
                        }
                    })
            }

            function getBookingTables(resources) {

                let employer_token = null;
                if ($("body").attr("employer_token") != undefined) {
                    employer_token = $("body").attr("employer_token");
                }

                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer_booking_reservation/get_booking_tables",
                    data: {
                        location_id: locationId,
                        employer_token: employer_token
                    }
                })
                    .done(function (data) {
                        resources(JSON.parse(data));
                    })
                    .fail(function (data) {
                        if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                            document.location.href = data.responseJSON.redirect_url;
                        }
                    })
            }

            function getOpeningHours(date, hours) {

                let employer_token = null;
                if ($("body").attr("employer_token") != undefined) {
                    employer_token = $("body").attr("employer_token");
                }

                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer_booking_reservation/get_opening_time_for_date",
                    data: {
                        location_id: locationId,
                        reservation_date: date,
                        employer_token: employer_token
                    }
                })
                    .done(function (data) {
                        hours(JSON.parse(data));
                        $("p.booking-summary").remove();
                        let appendBookingSummaryTotalWrapper = "<span class='booking-summary-total'></span>";
                        if (!$("div.fc-header-toolbar div.fc-toolbar-chunk").first().children("span.booking-summary-total").length) {
                            $("div.fc-header-toolbar div.fc-toolbar-chunk").first().append(appendBookingSummaryTotalWrapper);
                        }
                        $("span.booking-summary-total").empty();
                        if (calendar.view.type === 'resourceTimelineMonth' || calendar.view.type === 'resourceTimelineWeek') {
                            let appendBookingSummaryWrapper = "<p class='booking-summary'>(0/0)</p>";
                            let dateToday = new Date(todayDate);
                            $("tr.fc-timeline-header-row th.fc-timeline-slot").each(function () {
                                let slotDate = new Date($(this).data("date"));
                                if (Number(slotDate.getTime()) < Number(dateToday.getTime())){
                                    return;
                                }
                                if (!$(this).children("p.booking-summary").length) {
                                    $(this).append(appendBookingSummaryWrapper);
                                }
                            });
                            getBookingSummaryWeekAndMonth();
                        }
                        if (calendar.view.type === 'resourceTimeline') {
                            getBookingSummaryDay();
                        }
                    })
                    .fail(function (data) {
                        if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                            document.location.href = data.responseJSON.redirect_url;
                        }
                    })
            }

            function getBookingBlockingList(type, date, bookingBlockingList) {
                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer_booking_blocking/list",
                    data: {
                        location_id: locationId,
                        type: type,
                        date: date,
                    }
                })
                    .done(function (data) {
                        bookingBlockingList(data);
                    })
                    .fail(function (data) {
                        if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                            document.location.href = data.responseJSON.redirect_url;
                        }
                    })
            }

            function updateBookingReservation(event, table = null, response) {
                let tableId = null;
                if (table !== null) {
                    tableId = table.id;
                }

                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer_booking_reservation/update",
                    data: {
                        location_id: locationId,
                        booking_reservation_id: event.id,
                        reservation_date: event.start.toISOString(),
                        reservation_date_end: event.end.toISOString(),
                        table_id: tableId,
                        calendar_date: calendarDate

                    }
                })
                    .done(function (data) {
                        if (data.booking_reservations !== undefined && data.booking_reservations !== null) {
                            let event = JSON.parse(data.booking_reservations);
                            let calendarEvent = calendar.getEventById(event[0].id);
                            calendarEvent.remove();
                            calendar.addEventSource(event);
                            $(".popover").remove();
                            dataGraph = data.graph;
                            tableGraph();
                        }
                    })
                    .fail(function (data) {
                        if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                            document.location.href = data.responseJSON.redirect_url;
                        }
                        response(data.responseJSON);
                    })
            }


            $(document).on("click", "#booking-blocking-from-event-modal-button", function (e) {
                e.preventDefault();
                $(this).blur();
                $('#modal-booking-reservation').modal('hide');
                setTimeout(function () {
                    $('#modal-booking-reservation').remove();
                }, 500);

                getBookingBlockingModal($(this).data('start-date'), $(this).data('end-date'), $(this).data('type'), $(this).data('table-id'), function (modal) {
                    $('#content').append(modal);
                    if ($('#modal-booking-blocking').length) {
                        $('#modal-booking-blocking').modal('show');
                    }
                    if ($('#modal-booking-unblocking').length) {
                        $('#modal-booking-unblocking').modal('show');
                    }
                });
            });

            function removeBlockedTimeslots(timeslotArray, table_id) {
                let tableBlockedTimeslots = document.querySelectorAll(`.slot-blocked-wrapper[data-table-id="${table_id}"]`);
                timeslotArray.forEach(timeslot => {
                    Array.from(tableBlockedTimeslots).forEach(function (slot) {
                        let blockedTimeslotDate = new Date($(slot).data('timeslot'));
                        let activatedTimeslotDate = new Date(timeslot);
                        if (blockedTimeslotDate.getTime() === activatedTimeslotDate.getTime()) {
                            $(slot).remove();
                        }
                    });
                });
            }

            function markBlockedTimeslots(timeslotArray, table_id) {
                let resourceTableRows = $('.fc-scroller-harness .fc-scroller .fc-timeline-body .fc-scrollgrid-sync-table .fc-timeline-lane.fc-resource');
                let numberOfResourceRows = 0;
                let indexOfResourceRows = 0;
                resourceTableRows.each(function (index) {
                    if ($(this).attr('data-resource-id') === table_id) {
                        indexOfResourceRows = index;
                        return false;
                    }
                    numberOfResourceRows++;
                });
                timeslotArray.forEach(timeslot => {
                    let timeSlotDate = new Date(timeslot);
                    let resourceTimeSlots = $("div.fc-timeline-body div.fc-timeline-slots td.fc-timeline-slot");
                    let slotWidth = $("div.fc-timeline-slots td.fc-timeline-slot.fc-timeline-slot-lane").first().outerWidth();
                    let numberOfSlots = 0;
                    resourceTimeSlots.each(function () {
                        let slotDate = new Date($(this).attr('data-date'));
                        if (slotDate.getTime() === timeSlotDate.getTime()) {
                            let left = numberOfSlots * slotWidth + 2;
                            let top = numberOfResourceRows * 39;
                            let timelineSlotMarkerWrapper = $("<div>");
                            timelineSlotMarkerWrapper.css('left', left);
                            timelineSlotMarkerWrapper.css('top', top);
                            timelineSlotMarkerWrapper.addClass('slot-blocked-wrapper');
                            timelineSlotMarkerWrapper.attr('data-table-id', table_id);
                            timelineSlotMarkerWrapper.attr('data-timeslot', timeslot);
                            let timelineSlotMarker = $("<div>");
                            timelineSlotMarker.addClass('slot-blocked');
                            timelineSlotMarkerWrapper.append(timelineSlotMarker);
                            let resourceTableRow = $('.fc-scroller-harness .fc-scroller .fc-timeline-body .fc-scrollgrid-sync-table .fc-timeline-lane.fc-resource').eq(indexOfResourceRows);
                            resourceTableRow.append(timelineSlotMarkerWrapper);
                        }
                        numberOfSlots++;
                    });
                });
            }

            $(document).on("click", "#booking-blocking-form-cancel-button", function (e) {
                e.preventDefault();
                $(this).blur();
                $('#modal-booking-blocking').modal('hide');
                setTimeout(function () {
                    $('#modal-booking-blocking').remove();
                }, 500);
            });

            $(document).on("click", "#booking-unblocking-form-cancel-button", function (e) {
                e.preventDefault();
                $(this).blur();
                $('#modal-booking-unblocking').modal('hide');
                setTimeout(function () {
                    $('#modal-booking-unblocking').remove();
                }, 500);
            });

            $(document).on("submit", "#booking-blocking-form", function (e) {
                e.preventDefault();
                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer_booking_blocking/new",
                    data: {
                        serialized_post: $(this).serialize()
                    }
                })
                    .done(function (data) {

                        $('#booking-blocking-form-submit-button').blur();
                        $('#modal-booking-blocking').modal('hide');
                        setTimeout(function () {
                            $('#modal-booking-blocking').remove();
                        }, 500);

                        if (calendar.view.type === 'resourceTimelineMonth' || calendar.view.type === 'resourceTimelineWeek') {
                            let startDate = calendar.view.activeStart;
                            let endDate = calendar.view.activeEnd;
                            let currentDate = new Date(startDate);
                            while (currentDate < endDate) {
                                let formatedCurrentDate = formatDate(currentDate);
                                if (data.disabled_dates.includes(formatedCurrentDate)) {
                                    let dayCells = document.querySelectorAll(`.fc-day[data-date="${formatedCurrentDate}"]`);
                                    dayCells.forEach(cell => {
                                        cell.classList.add('blocked');
                                    });
                                }
                                currentDate.setDate(currentDate.getDate() + 1);
                            }
                        }
                        if (calendar.view.type === 'resourceTimeline') {
                            if (data.disabled_dates.length !== 0) {
                                let tableCells = document.querySelectorAll(`.fc-resource[data-resource-id="${data.table_id}"]`);
                                tableCells.forEach(cell => {
                                    cell.classList.add('blocked');
                                });
                            }
                            if (data.disabled_timeslots.length !== 0) {
                                markBlockedTimeslots(data.disabled_timeslots, data.table_id)
                            }
                        }
                        if (data.table_has_booking_reservation !== undefined && data.table_has_booking_reservation !== null) {
                            setTimeout(function () {
                                alert(data.table_has_booking_reservation);
                            }, 500);
                        }

                    })
                    .fail(function (data) {
                        if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                            document.location.href = data.responseJSON.redirect_url;
                        }
                        if (data.responseJSON.error_message !== undefined && data.responseJSON.error_message !== null) {
                            prependAlert('#booking-blocking-form-button-wrapper', data.responseJSON.error_message, 'danger', null, '#booking-blocking-form');
                        }
                    })
            });

            $(document).on("submit", "#booking-unblocking-form", function (e) {
                e.preventDefault();
                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer_booking_blocking/delete",
                    data: {
                        serialized_post: $(this).serialize()
                    }
                })
                    .done(function (data) {

                        $('#booking-unblocking-form-submit-button').blur();
                        $('#modal-booking-unblocking').modal('hide');
                        setTimeout(function () {
                            $('#modal-booking-unblocking').remove();
                        }, 500);

                        if (calendar.view.type === 'resourceTimelineMonth' || calendar.view.type === 'resourceTimelineWeek') {
                            let startDate = calendar.view.activeStart;
                            let endDate = calendar.view.activeEnd;
                            let currentDate = new Date(startDate);
                            while (currentDate < endDate) {
                                let formatedCurrentDate = formatDate(currentDate);
                                if (data.activated_dates.includes(formatedCurrentDate)) {
                                    let dayCells = document.querySelectorAll(`.fc-day[data-date="${formatedCurrentDate}"]`);
                                    dayCells.forEach(cell => {
                                        cell.classList.remove('blocked');
                                    });
                                }
                                currentDate.setDate(currentDate.getDate() + 1);
                            }
                        }
                        if (calendar.view.type === 'resourceTimeline') {
                            let tableCells = document.querySelectorAll(`.fc-resource[data-resource-id="${data.table_id}"]`);
                            tableCells.forEach(cell => {
                                cell.classList.remove('blocked');
                            });
                            if (data.activated_timeslots.length !== 0) {
                                removeBlockedTimeslots(data.activated_timeslots, data.table_id)
                            }
                        }

                    })
                    .fail(function (data) {
                        if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                            document.location.href = data.responseJSON.redirect_url;
                        }
                        if (data.responseJSON.error_message !== undefined && data.responseJSON.error_message !== null) {
                            prependAlert('#booking-unblocking-form-button-wrapper', data.responseJSON.error_message, 'danger', null, '#booking-unblocking-form');
                        }
                    })
            });

            function getBookingBlockingModal(startDate, endDate, type, tableId = null, modal) {
                if ($('#modal-booking-blocking').length) {
                    $('#modal-booking-blocking').remove();
                }
                if ($('#modal-booking-unblocking').length) {
                    $('#modal-booking-unblocking').remove();
                }
                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer_booking_blocking/get_modal",
                    data: {
                        location_id: locationId,
                        start_date: startDate,
                        end_date: endDate,
                        type: type,
                        table_id: tableId
                    }
                })
                    .done(function (data) {
                        modal(data.html);
                    })
                    .fail(function (data) {
                        if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                            document.location.href = data.responseJSON.redirect_url;
                        }
                    })
            }

            function getBookingReservationModal(info, modal) {
                if ($('#modal-booking-reservation').length) {
                    $('#modal-booking-reservation').remove();
                }
                let bookingReservationId = null;
                let reservationDate = null;
                let reservationDateEnd = null;
                let tableId = null;
                if (info.event !== undefined && info.event !== null) {
                    bookingReservationId = info.event.id;
                }
                if (info.startStr !== undefined && info.startStr !== null) {
                    reservationDate = info.startStr;
                }
                if (info.endStr !== undefined && info.endStr !== null) {
                    reservationDateEnd = info.endStr;
                }
                if (info.resource !== undefined && info.resource !== null) {
                    tableId = info.resource.id;
                }

                let employer_token = null;
                if ($("body").attr("employer_token") != undefined) {
                    employer_token = $("body").attr("employer_token");
                }

                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer_booking_reservation/get_modal",
                    data: {
                        location_id: locationId,
                        booking_reservation_id: bookingReservationId,
                        reservation_date: reservationDate,
                        reservation_date_end: reservationDateEnd,
                        table_id: tableId,
                        employer_token: employer_token
                    }
                })
                    .done(function (data) {
                        modal(data.html);
                    })
                    .fail(function (data) {
                        if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                            document.location.href = data.responseJSON.redirect_url;
                        }
                    })
            }

            $(document).on("click", "#delete-booking-reservation", function () {

                let locationId = $(this).data("location-id");
                let reservationDate = $(this).data("reservation-date");
                let bookingReservationId = $(this).data("booking-reservation-id");
                let confirmMessage = $(this).data("confirm-message");

                if (!confirm(confirmMessage)) {
                    return false;
                }

                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer_booking_reservation/delete",
                    data: {
                        location_id: locationId,
                        reservation_date: reservationDate,
                        booking_reservation_id: bookingReservationId,
                        calendar_date: calendarDate
                    }
                })
                    .done(function (data) {

                        if (data.booking_summary !== undefined && data.booking_summary !== null) {
                            bookingSummary = JSON.parse(data.booking_summary);
                            if (calendar.view.type === 'resourceTimelineMonth' || calendar.view.type === 'resourceTimelineWeek') {
                                getBookingSummaryWeekAndMonth();
                            }
                            if (calendar.view.type === 'resourceTimeline') {
                                getBookingSummaryDay();
                            }
                            popupAlert();
                            let calendarEvent = calendar.getEventById(bookingReservationId);
                            calendarEvent.remove();
                            $('#modal-booking-reservation').modal('hide');
                            setTimeout(function () {
                                $('#modal-booking-reservation').remove();
                            }, 2000);
                            dataGraph = data.graph;
                            tableGraph();
                        }

                    })
                    .fail(function (data) {

                        if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                            document.location.href = data.responseJSON.redirect_url;
                        }

                        if (data.responseJSON.error_message !== undefined && data.responseJSON.error_message !== null) {
                            prependAlert('#booking-reservation-form-button-wrapper', data.responseJSON.error_message, 'danger', null, '#booking-reservation-from-admin-form');
                        }

                    });
                    return false;
            });


            $(document).on("submit", "#booking-reservation-from-admin-form", function (e) {
                e.preventDefault();
                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer_booking_reservation/update",
                    data: {
                        serialized_post: $(this).serialize()
                    }
                })
                    .done(function (data) {
                        if (data.booking_reservations !== undefined && data.booking_reservations !== null && data.new_event !== undefined && data.new_event !== null) {
                            let lastCheckedForNewEvents = new Date($('#calendar').attr('data-last-updated-date'));
                            let lastEventDate = new Date(data.last_updated_booking_reservations_date);
                            if (lastCheckedForNewEvents < lastEventDate) {
                                $('#calendar').attr('data-last-updated-date', data.last_updated_booking_reservations_date);
                                let event = JSON.parse(data.booking_reservations);
                                calendar.addEventSource(event);
                            }
                        }
                        if (data.booking_reservations !== undefined && data.booking_reservations !== null && data.update_event !== undefined && data.update_event !== null) {
                            let event = JSON.parse(data.booking_reservations);
                            let calendarEvent = calendar.getEventById(event[0].id);
                            calendarEvent.remove();
                            calendar.addEventSource(event);
                        }
                        if (data.booking_summary !== undefined && data.booking_summary !== null) {
                            bookingSummary = JSON.parse(data.booking_summary);
                            if (calendar.view.type === 'resourceTimelineMonth' || calendar.view.type === 'resourceTimelineWeek') {
                                getBookingSummaryWeekAndMonth();
                            }
                            if (calendar.view.type === 'resourceTimeline') {
                                getBookingSummaryDay();
                            }
                        }
                        $('#modal-booking-reservation').modal('hide');
                        setTimeout(function () {
                            $('#modal-booking-reservation').remove();
                        }, 2000);
                        if (data.overbooked !== undefined && data.overbooked !== null) {
                            setTimeout(function () {
                                alert(data.overbooked);
                            }, 1000);
                        }
                        if (data.underbooked !== undefined && data.underbooked !== null) {
                            setTimeout(function () {
                                alert(data.underbooked);
                            }, 1000);
                        }
                        if (data.booking_blocking !== undefined && data.booking_blocking !== null) {
                            setTimeout(function () {
                                alert(data.booking_blocking);
                            }, 1000);
                        }
                        dataGraph = data.graph;
                        tableGraph();
                    })
                    .fail(function (data) {
                        if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                            document.location.href = data.responseJSON.redirect_url;
                        }
                        if (data.responseJSON.error_message !== undefined && data.responseJSON.error_message !== null) {
                            prependAlert('#booking-reservation-form-button-wrapper', data.responseJSON.error_message, 'danger', null, '#booking-reservation-from-admin-form');
                        }
                    })
                return false;
            });

            function formatDate(date) {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            }

            function headerDateClickHandler(event) {
                const dateStr = event.currentTarget.getAttribute('data-date');
                calendarDate = dateStr;
                calendar.changeView('resourceTimeline');
                calendar.gotoDate(dateStr);
                getBookingReservationGraph();
                /*getBookingBlockingModal(dateStr, null, 'day', null, function (modal) {
                    $('#content').append(modal);
                    if ($('#modal-booking-blocking').length) {
                        $('#modal-booking-blocking').modal('show');
                    }
                    if ($('#modal-booking-unblocking').length) {
                        $('#modal-booking-unblocking').modal('show');
                    }
                });*/
            }

            function resourceClickHandler(event) {
                let tableId = event.currentTarget.getAttribute('data-resource-id');
                if (calendar.view.type === 'resourceTimeline') {
                    getBookingBlockingModal(formatDate(calendar.getDate()), null, 'table', tableId, function (modal) {
                        $('#content').append(modal);
                        if ($('#modal-booking-blocking').length) {
                            $('#modal-booking-blocking').modal('show');
                        }
                        if ($('#modal-booking-unblocking').length) {
                            $('#modal-booking-unblocking').modal('show');
                        }
                    });
                }
            }

            let calendarEl = document.getElementById('calendar');
            let calendar = new FullCalendar.Calendar(calendarEl, {
                schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
                themeSystem: 'standard',
                initialView: 'resourceTimeline',
                initialDate: todayDate,
                editable: true,
                height: 'auto',
                weekNumberCalculation: 'ISO',
                headerToolbar: {
                    left: 'resourceTimelineMonth,resourceTimelineWeek,resourceTimeline',
                    center: 'title',
                    right: 'prev,next today'
                },
                buttonText: {
                    today: 'i dag',
                    month: 'måned',
                    week: 'uke',
                    day: 'dag',
                    list: 'list',
                    resourceTimeline: "dag"
                },
                resourceAreaHeaderContent: 'Bord',
                views: {
                    resourceTimeline: {
                        type: 'resourceTimeline',
                        slotDuration: '00:15:00'
                    },
                    resourceTimelineWeek: {
                        type: 'resourceTimelineWeek',
                        duration: { weeks: 1 },
                        slotDuration: {days: 1},
                        slotLabelFormat:{
                            weekday: 'long'
                        }
                    },
                    resourceTimelineMonth: {
                        type: 'resourceTimelineMonth',
                        duration: { month: 1 },
                        slotDuration: {days: 1},
                        slotLabelFormat:{
                            day: '2-digit'
                        }
                    }
                },
                eventDidMount: function (eventInfo) {
                    if (eventInfo.event.extendedProps.popover !== undefined) {
                        $(eventInfo.el).popover({
                            placement: 'right',
                            trigger: 'hover',
                            html: true,
                            content: eventInfo.event.extendedProps.popover,
                            container: 'body'
                        });
                    }
                },
                resources: function (fetchInfo, successCallback) {
                    getBookingTables(function (resources) {
                        successCallback(resources);
                    });
                },
                eventSources: function (eventInfo, successCallback) {
                    calendarDate = eventInfo.startStr;
                    getBookingReservations(function (events) {
                        successCallback(events);
                    });
                },
                datesSet: function (dateInfo) {
                    getOpeningHours(dateInfo.startStr, function (hours) {
                        calendar.setOption('slotMinTime', hours.slotMinTime);
                        calendar.setOption('slotMaxTime', hours.slotMaxTime);
                    });
                    let blockedCells = document.querySelectorAll('.fc-day.blocked, .fc-resource.blocked');
                    blockedCells.forEach(cell => {
                        cell.classList.remove('blocked');
                    });
                    $('.slot-blocked-wrapper').remove();
                    if (calendar.view.type === 'resourceTimelineMonth' || calendar.view.type === 'resourceTimelineWeek') {
                        let startDate = dateInfo.start;
                        let endDate = dateInfo.end;
                        let currentDate = new Date(startDate);
                        getBookingBlockingList('day', null, function (bookingBlockingList) {
                            while (currentDate < endDate) {
                                let formatedCurrentDate = formatDate(currentDate);
                                if (bookingBlockingList.includes(formatedCurrentDate)) {
                                    let dayCells = document.querySelectorAll(`.fc-day[data-date="${formatedCurrentDate}"]`);
                                    dayCells.forEach(cell => {
                                        cell.classList.add('blocked');
                                    });
                                }
                                currentDate.setDate(currentDate.getDate() + 1);
                            }
                        });
                        document.querySelectorAll('tr.fc-timeline-header-row th.fc-timeline-slot').forEach(cell => {
                            cell.removeEventListener('click', headerDateClickHandler);
                        });
                        setTimeout(() => {
                            document.querySelectorAll('tr.fc-timeline-header-row th.fc-timeline-slot').forEach(cell => {
                                cell.addEventListener('click', headerDateClickHandler);
                            });
                        }, 0);
                    }
                    if (calendar.view.type === 'resourceTimeline') {
                        getBookingBlockingList('table', formatDate(calendar.getDate()), function (bookingBlockingList) {
                            bookingBlockingList.forEach(function (table_id) {
                                let tableCells = document.querySelectorAll(`.fc-resource[data-resource-id="${table_id}"]`);
                                tableCells.forEach(cell => {
                                    cell.classList.add('blocked');
                                });
                            });
                        });
                        document.querySelectorAll('td.fc-datagrid-cell.fc-resource').forEach(cell => {
                            cell.removeEventListener('click', resourceClickHandler);
                        });
                        setTimeout(() => {
                            document.querySelectorAll('td.fc-datagrid-cell.fc-resource').forEach(cell => {
                                cell.addEventListener('click', resourceClickHandler);
                            });
                        }, 0);
                        getBookingBlockingList('slot', formatDate(calendar.getDate()), function (bookingBlockingList) {
                            Object.entries(bookingBlockingList).forEach(([tableId, timeslots]) => {
                                markBlockedTimeslots(timeslots, tableId);
                            });
                        });
                        if (calendarDate !== dateInfo.startStr) {
                            calendarDate = dateInfo.startStr;
                        }
                    }
                    $("button.fc-today-button").prop("disabled", false);
                },
                eventDrop: function (info) {
                    updateBookingReservation(info.event, info.newResource, function (response) {
                        if (response.error_message !== undefined) {
                            alert(response.error_message);
                            info.revert();
                        }
                    });
                },
                eventResize: function (info) {
                    updateBookingReservation(info.event, null, function (response) {
                        if (response.error_message !== undefined) {
                            alert(response.error_message);
                            info.revert();
                        }
                    });
                },
                eventClick: function (info) {
                    getBookingReservationModal(info, function (modal) {
                        $('#content').append(modal);
                        $('#modal-booking-reservation').modal('show');
                    });
                },
                selectable: true,
                select: function (info) {
                    if (calendar.view.type === 'resourceTimeline') {
                        if (info.resource.extendedProps.notSelectable !== undefined) {
                            return false;
                        }
                        getBookingReservationModal(info, function (modal) {
                            $('#content').append(modal);
                            if ($('#modal-booking-reservation').length) {
                                $('#modal-booking-reservation').modal('show');
                            } else if ($('#modal-booking-unblocking').length) {
                                $('#modal-booking-unblocking').modal('show');
                            }
                        });
                    }
                    if (calendar.view.type === 'resourceTimelineMonth' || calendar.view.type === 'resourceTimelineWeek') {
                        getBookingBlockingModal(info.startStr, info.endStr, 'day', null, function (modal) {
                            $('#content').append(modal);
                            if ($('#modal-booking-blocking').length) {
                                $('#modal-booking-blocking').modal('show');
                            }
                            if ($('#modal-booking-unblocking').length) {
                                $('#modal-booking-unblocking').modal('show');
                            }
                        });
                    }
                }
            });
            calendar.setOption('locale', 'NO-nb');
            calendar.setOption('resourceAreaWidth', '15%');
            calendar.render();

            function getNewBookingReservations() {
                getBookingReservations(function (events) {
                    calendar.addEventSource(events);
                }, true);
                setTimeout(getNewBookingReservations, 5000);
            }

            getNewBookingReservations();

            $(document).on("click",
                "button.fc-resourceTimelineMonth-button, " +
                "button.fc-resourceTimelineWeek-button, " +
                "button.fc-resourceTimeline-button, " +
                "button.fc-prev-button, " +
                "button.fc-next-button, " +
                "button.fc-today-button", function () {
                getBookingReservationGraph();
            });

            function tableGraph() {
                if (calendar.view.type === 'resourceTimeline') {
                    if (!$('div#booking-bar-graph').length) {
                        $('tr.fc-scrollgrid-section-footer td:last-child div.fc-scrollgrid-sticky-shim').append('<div id="booking-bar-graph"></div>');
                    }
                    $('tr.fc-scrollgrid-section-footer td:last-child div.fc-scrollgrid-sticky-shim').css('height', '190px');
                    $('tr.fc-scrollgrid-section-footer').removeClass('fc-scrollgrid-section-sticky');
                    $('div#booking-bar-graph').empty();
                    setTimeout(function () {
                        barChart(dataGraph);
                    }, 1500);

                } else {
                    $('div#booking-bar-graph').remove();
                    $('tr.fc-scrollgrid-section-footer td:last-child div.fc-scrollgrid-sticky-shim').css('height', '1px');
                    if (!$('tr.fc-scrollgrid-section-footer').hasClass('fc-scrollgrid-section-sticky')) {
                        $('tr.fc-scrollgrid-section-footer').addClass('fc-scrollgrid-section-sticky');
                    }
                }
            }

            function getBookingReservationGraph() {
                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer_booking_reservation/get_graph",
                    data: {
                        location_id: locationId,
                        calendar_date: calendarDate
                    }
                })
                    .done(function (data) {
                        dataGraph = data.graph;
                        tableGraph();
                    })
                    .fail(function (data) {
                        if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                            document.location.href = data.responseJSON.redirect_url;
                        }
                    })
            }

            let barChartDate = null;
            function barChart(primalData) {

                if (barChartDate !== calendarDate){
                    barChartDate = calendarDate;
                    $('#booking-bar-graph').empty();
                }

                let width = parseInt($('tr.fc-scrollgrid-section-footer td:last-child div.fc-scrollgrid-sticky-shim').css('width'), 10);
                let minWidth = parseInt($('tr.fc-scrollgrid-section-footer td:last-child div.fc-scrollgrid-sticky-shim').css('min-width'), 10);
                if (minWidth > width) {
                    width = minWidth;
                }

                let open = calendar.getOption('slotMinTime');
                let close = calendar.getOption('slotMaxTime');
                let start = new Date(`1970-01-01T${open}`);
                let end = new Date(`1970-01-01T${close}`);
                let timeDifference = (end - start) / 60000;
                let numberOfTimeSlots = Math.ceil(timeDifference / 15);
                let remainingTimeSlotsToFullHour = numberOfTimeSlots % 4;
                if (remainingTimeSlotsToFullHour > 0) {
                    let extraTimeSlots = 4 - remainingTimeSlotsToFullHour
                    if (extraTimeSlots > 0) {
                        let slotWidth = 30;
                        if ($("div.fc-timeline-slots td.fc-timeline-slot.fc-timeline-slot-lane").first().length) {
                            slotWidth = $("div.fc-timeline-slots td.fc-timeline-slot.fc-timeline-slot-lane").first().outerWidth();
                        }
                        width = width + (extraTimeSlots * slotWidth);
                    }
                }

                Highcharts.chart('booking-bar-graph', {
                    chart: {
                        type: 'line',
                        height: 200,
                        width: width
                    },
                    exporting: {enabled: false},
                    title: false,
                    xAxis: {
                        categories: primalData.hour,
                        title: {
                            enabled: false
                        }
                    },
                    yAxis: {
                        labels: {
                            enabled: false
                        },
                        title: {
                            enabled: false
                        }
                    },
                    credits: {enabled: false},
                    series: [{
                        showInLegend: false,
                        data: primalData.number_of_bookings,
                        name: 'Antall bookinger'
                    },
                        {
                            showInLegend: false,
                            data: primalData.number_of_seats,
                            name: 'Antall seter'
                        }]
                });
            }

        }

    }
);
